"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiContractsClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
const ContractsConverter_1 = require("../ContractsConverter");
const PageableConverter_1 = require("../../common/model/PageableConverter");
const IdExtractor_1 = require("./IdExtractor");
class ApiContractsClient extends ApiSubClient_1.ApiSubClient {
    getAll(page, projection) {
        const contractsLink = this.getLinkOrThrow('contracts');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(contractsLink.href, {
            page: page.page,
            size: page.size,
            projection: projection,
        }))
            .then(({ data }) => PageableConverter_1.PageableConverter.convert(data, 'contracts', ContractsConverter_1.ContractsConverter.fromResource));
    }
    async create(contract) {
        const contractsLink = this.getLinkOrThrow('createContracts');
        const contractCreationResponse = await this.axios.post((0, expandUrlTemplate_1.default)(contractsLink.href, {}), {
            ...contract,
            contractDates: ContractsConverter_1.ContractsConverter.formatDates(contract.contractDates),
        });
        const id = IdExtractor_1.IdExtractor.extract(contractCreationResponse.headers?.location);
        return Promise.resolve({
            value: id ? id : 'id value not available',
        });
    }
    async update(id, updateRequest) {
        const contractLink = this.getLinkOrThrow('contract');
        await this.axios.patch((0, expandUrlTemplate_1.default)(contractLink.href, { id }), {
            ...updateRequest,
            contractDates: ContractsConverter_1.ContractsConverter.formatDates(updateRequest.contractDates),
        }, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
        });
    }
    get(id) {
        const contractLink = this.getLinkOrThrow('contract');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(contractLink.href, { id }))
            .then((response) => ContractsConverter_1.ContractsConverter.fromResource(response.data));
    }
    getSignedLink(filename) {
        this.axios.interceptors.request.use((request) => {
            return request;
        });
        this.axios.interceptors.response.use((response) => {
            return response;
        });
        const link = this.getLinkOrThrow('createContractsSignedUploadLink').href;
        return this.axios
            .post(link, {
            filename,
        })
            .then((it) => {
            return it.headers.location;
        });
    }
}
exports.ApiContractsClient = ApiContractsClient;
//# sourceMappingURL=ApiContractsClient.js.map